import { render, staticRenderFns } from "./Educ-pop.vue?vue&type=template&id=35f35ca5"
import script from "./Educ-pop.vue?vue&type=script&lang=js"
export * from "./Educ-pop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports